import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-modal-success',
  templateUrl: './modal-success.component.html',
  styleUrls: ['./modal-success.component.css'],
  standalone: true
})
export class ModalSuccessComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<ModalSuccessComponent>) {}

  ngOnInit(): void {}

  closeModal(): void {
    this.dialogRef.close();
  }
}
